import { render, staticRenderFns } from "./view-advantage.vue?vue&type=template&id=6fcda4de&scoped=true&"
import script from "./view-advantage.vue?vue&type=script&lang=js&"
export * from "./view-advantage.vue?vue&type=script&lang=js&"
import style0 from "./view-advantage.vue?vue&type=style&index=0&id=6fcda4de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcda4de",
  null
  
)

export default component.exports